import { ArticlesService } from "../../common/api.service"
import ClientHelper from '../../common/client.helper'

export default {
  namespaced: true,
  state: {
    articles: [],
    fullArticles: [],
    articlesStatus: false,
    firstPriority: 1,
    firstRenderPriority: 16,
  },
  mutations: {
    setArticles(state, payload) {
      let filterArticles = ClientHelper.filterArticles(payload.articles)
      let sortArticles = ClientHelper.sortArticles(filterArticles)
      state.articles = filterArticles
      state.articlesStatus = true
      state.firstPriority = sortArticles[0].priority
      state.firstRenderPriority = sortArticles[16].priority
    },
    setFullArticles(state, payload) {
      state.fullArticles = ClientHelper.filterArticles(payload.articles)
    },
  },
  actions: {
    async fetchArticles({ commit }, locale) {
      return await ArticlesService.get(locale)
        .then(({ data }) => {
          commit("setArticles", data)
          commit("setLocale", data.locale, { root: true })
          return data
        })
        .catch((reason) => {
          console.log(reason.message)
        })
    },
    async fetchFullArticles({ commit }) {
      return await ArticlesService.get("jp")
        .then(({ data }) => {
          commit("setFullArticles", data)
          return data
        })
        .catch((reason) => {
          console.log(reason.message)
        })
    },
  },
  getters: {
  }
}
